import { render, staticRenderFns } from "./temoignages-abonnement.vue?vue&type=template&id=88b184aa&scoped=true"
import script from "./temoignages-abonnement.vue?vue&type=script&lang=js"
export * from "./temoignages-abonnement.vue?vue&type=script&lang=js"
import style0 from "./temoignages-abonnement.vue?vue&type=style&index=0&id=88b184aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b184aa",
  null
  
)

export default component.exports